import { render } from "./modalTerms.vue?vue&type=template&id=441787e5&scoped=true&ts=true"
import script from "./modalTerms.vue?vue&type=script&lang=ts"
export * from "./modalTerms.vue?vue&type=script&lang=ts"

import "./modalTerms.vue?vue&type=style&index=0&id=441787e5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441787e5"]])

export default __exports__